import { Link } from "react-router-dom";
import { Table } from "antd";
import "./card.css";
import moment from "moment";

const DEFAULT_SUPPLIER_INVOICE_COLUMNS = [
  {
    title: "Invoice ",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date) => moment(date).format("ll"),
  },
  {
    title: "Total Amount",
    dataIndex: "total_amount",
    key: "total_amount",
  },
  {
    title: "Discount",
    dataIndex: "discount",
    key: "discount",
    responsive: ["md"],
  },
  {
    title: "Paid Amount",
    dataIndex: "paid_amount",
    key: "paid_amount",
    responsive: ["md"],
  },
  {
    title: "Due Amount",
    dataIndex: "due_amount",
    key: "due_amount",
    responsive: ["md"],
  },
  {
    title: "Action",
    dataIndex: "id",
    key: "payment",
    render: (id) => (
      <Link to={`/payment/supplier/${id}`}>
        <button className="btn btn-dark btn-sm">Payment</button>
      </Link>
    ),
  },
];

function SupplierInvoiceTable({ list, linkTo = "/purchase", columns: columnsProp, scroll: scrollProp }) {
  const defaultColumns = DEFAULT_SUPPLIER_INVOICE_COLUMNS.map((col) =>
    col.key === "id"
      ? { ...col, render: (id) => <Link to={`${linkTo}/${id}`}>{id}</Link> }
      : col
  );
  const columns = columnsProp ?? defaultColumns;
  const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
  const scroll = scrollProp ?? { x: true };

  return (
    <Table
      scroll={scroll}
      loading={!list}
      columns={columns}
      dataSource={list ? addKeys(list) : []}
      size="small"
    />
  );
}

export default SupplierInvoiceTable;
export { DEFAULT_SUPPLIER_INVOICE_COLUMNS };
